import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { NotificationState } from '../state/notification.state';
import { AddAllOrder, NotificationChanged, ResetOrderInEditMode, SetOrderInEditMode, UpdateOneOrder } from '../action/notification.action';
import { OrderEditMode } from '../../00_modules/core/models/OrderEditMode';
import { Observable } from 'rxjs';
import { OrderInEditMode, OrderStateChanged } from '../interface/notification.interface';

@Injectable({
    providedIn: 'root',
})
export class NotificationFacade {
    orderStepChanged$: Observable<OrderStateChanged> = inject(Store).select(NotificationState.getOrderStateChanged);
    orders$: Observable<OrderEditMode[]> = inject(Store).select(NotificationState.getOrders);
    orderInEditMode$: Observable<OrderInEditMode> = inject(Store).select(NotificationState.getOrderInEditMode);

    constructor(private store: Store) {}

    public setOrderInEditMode(order: OrderInEditMode) {
        this.store.dispatch(new SetOrderInEditMode(order));
    }

    public resetOrderInEditMode() {
        this.store.dispatch(new ResetOrderInEditMode());
    }

    public notificationChanged(orderStateChanged: OrderStateChanged) {
        this.store.dispatch(new NotificationChanged(orderStateChanged));
    }

    public addAllOrder(orders: OrderEditMode[]) {
        this.store.dispatch(new AddAllOrder(orders));
    }

    public updateOneOrder(order: OrderEditMode) {
        this.store.dispatch(new UpdateOneOrder(order));
    }
}
